export const lookupConstants={
  FETCH_SECTORS:'FETCH_SECTORS',
  FETCH_INDUSTRY: 'FETCH_INDUSTRY',
  FETCH_EXCHANGE: 'FETCH_EXCHANGE',
  FETCH_COMPANY: 'FETCH_COMPANY',
  FETCH_USERS: 'FETCH_USERS',
  LOADED_ALL:'LOADED_ALL',
  LOOKUP_REQUEST:'LOOKUP_REQUEST',
  LOOKUP_REQUEST_END:'LOOKUP_REQUEST_END',
  FETCH_SECTORS_ONLY:'FETCH_SECTORS_ONLY',
 
}
